module.exports = __webpack_public_path__ + "media/lan/LogoColorIcon48-ab461157.png";